import Vue from 'vue';
import Vuex from 'vuex';

import ui from './modules/ui';
import auth from './modules/auth';
import chat from './modules/chat';
import support from './modules/support';
import notification from './modules/notification';
import messageTemplates from './modules/messageTemplates';
import audio from './modules/audio';
import feature from './modules/feature';
import gpt from './modules/gpt';

import adminChat from './modules/admin/chat';
import adminSupport from './modules/admin/support';
import adminClientVotes from './modules/admin/clientVotes';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    ui,
    auth,
    chat,
    support,
    notification,
    messageTemplates,
    audio,
    feature,
    gpt,
    adminChat,
    adminSupport,
    adminClientVotes,
  },
});

export default store;
